const accordianButton = document.querySelectorAll('.accordian')
const accordianArrow = document.querySelectorAll('#accordianArrow')

for(let i = 0; i < accordianButton.length; i++){
    accordianButton[i].addEventListener('click', () => {
        accordianButton[i].classList.toggle('active')

        let panel = accordianButton[i].nextElementSibling

        if(panel.style.maxHeight){
            panel.style.maxHeight = null
        }else{
            panel.style.maxHeight = panel.scrollHeight + 'px'
        }
    })
}